import {createContext as $l0qCG$createContext} from "react";
import $l0qCG$macrostrathyper from "@macrostrat/hyper";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $5b1ccb2009d628d6$exports = {};

$parcel$export($5b1ccb2009d628d6$exports, "LithologyContext", () => $5b1ccb2009d628d6$export$cd365f0801599660);
$parcel$export($5b1ccb2009d628d6$exports, "LithologyProvider", () => $5b1ccb2009d628d6$export$9c59de1c28f85122);


const $5b1ccb2009d628d6$export$cd365f0801599660 = (0, $l0qCG$createContext)({
    lithologies: []
});
function $5b1ccb2009d628d6$export$9c59de1c28f85122(props) {
    const { lithologies: lithologies, children: children } = props;
    // @ts-ignore
    return (0, $l0qCG$macrostrathyper)($5b1ccb2009d628d6$export$cd365f0801599660.Provider, {
        value: {
            lithologies: lithologies
        }
    }, children);
}


export {$5b1ccb2009d628d6$export$cd365f0801599660 as LithologyContext, $5b1ccb2009d628d6$export$9c59de1c28f85122 as LithologyProvider};
//# sourceMappingURL=column-components.f62db69a.js.map
